import {
  ArrowTopRightOnSquareIcon,
  LockClosedIcon,
} from '@heroicons/react/24/solid';

interface InternalCapabilityCalloutProps {
  onLearnMore?: () => void;
}

/**
 * InternalCapabilityCallout - Explains why an Aegis agent is required for internal capabilities
 *
 * Displays an informational callout when a capability has surface === 'internal',
 * explaining that internal capabilities scan internal network resources and must
 * be executed through a deployed Aegis agent.
 */
export function InternalCapabilityCallout({
  onLearnMore,
}: InternalCapabilityCalloutProps) {
  const handleLearnMoreClick = () => {
    onLearnMore?.();
  };

  return (
    <div
      role="region"
      aria-label="Internal capability information"
      data-testid="internal-capability-callout"
      className="rounded-lg border border-blue-200 bg-blue-50/50 p-4 dark:border-blue-800 dark:bg-blue-900/20"
    >
      <div className="flex items-start gap-3">
        <LockClosedIcon
          className="mt-0.5 size-5 shrink-0 text-blue-600 dark:text-blue-400"
          data-testid="internal-capability-lock-icon"
          aria-hidden="true"
        />
        <div className="flex flex-col gap-2">
          <h4 className="text-sm font-semibold tracking-wide text-blue-800 uppercase dark:text-blue-300">
            INTERNAL CAPABILITY
          </h4>
          <p className="text-sm text-blue-700 dark:text-blue-300">
            This capability scans internal network resources and must be
            executed through an Aegis agent deployed in the target environment.
          </p>
          <button
            type="button"
            onClick={handleLearnMoreClick}
            className="inline-flex items-center gap-1 text-sm font-medium text-blue-600 hover:text-blue-800 focus:underline focus:outline-none dark:text-blue-400 dark:hover:text-blue-200"
          >
            Learn more about Aegis agents
            <ArrowTopRightOnSquareIcon className="size-4" aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  );
}
